import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LandingPage } from './login/LandingPage';
import { AuthModal } from './login/AuthModal';

interface LoginPageProps {
  autoVerify?: boolean;
}

const LoginPage: React.FC<LoginPageProps> = ({ autoVerify = false }) => {
  const navigate = useNavigate();
  const [showAuthModal, setShowAuthModal] = useState(autoVerify);
  const [authMode, setAuthMode] = useState<'login' | 'signup'>('login');

  const handleGetStarted = () => {
    // Navigate to pre-auth wizard for new users
    navigate('/welcome');
  };

  const handleHaveAccount = () => {
    setAuthMode('login');
    setShowAuthModal(true);
  };

  const handleCloseAuthModal = () => {
    setShowAuthModal(false);
  };

  return (
    <>
      <LandingPage 
        onGetStarted={handleGetStarted}
        onHaveAccount={handleHaveAccount}
      />
      <AuthModal 
        isOpen={showAuthModal}
        onClose={handleCloseAuthModal}
        initialMode={authMode}
      />
    </>
  );
};

export default LoginPage;
